export const GET_SIFT_FRAUD_CONFIG_REQUESTED = 'brand/GET_SIFT_FRAUD_CONFIG_REQUESTED';
export const GET_SIFT_FRAUD_CONFIG_SUCCESS = 'brand/GET_SIFT_FRAUD_CONFIG_SUCCESS';
export const GET_SIFT_FRAUD_CONFIG_FAILURE = 'brand/GET_SIFT_FRAUD_CONFIG_FAILURE';

export const UPDATE_SIFT_FRAUD_CONFIG_REQUESTED = 'brand/UPDATE_SIFT_FRAUD_CONFIG_REQUESTED';
export const UPDATE_SIFT_FRAUD_CONFIG_SUCCESS = 'brand/UPDATE_SIFT_FRAUD_CONFIG_SUCCESS';
export const UPDATE_SIFT_FRAUD_CONFIG_FAILURE = 'brand/UPDATE_SIFT_FRAUD_CONFIG_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  siftFraudList: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_SIFT_FRAUD_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        siftFraudList: [],
      };
    }
    case GET_SIFT_FRAUD_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        siftFraudList: action.result,
      };
    }
    case GET_SIFT_FRAUD_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
        siftFraudList: [],
      };
    }
    case UPDATE_SIFT_FRAUD_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_SIFT_FRAUD_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_SIFT_FRAUD_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getSiftConfig = (brandId) => {
  return {
    types: [GET_SIFT_FRAUD_CONFIG_REQUESTED, GET_SIFT_FRAUD_CONFIG_SUCCESS, GET_SIFT_FRAUD_CONFIG_FAILURE],
    promise: client => client.get(`getSiftConfig/${brandId}`)
  };
};

export const updateSiftConfig = (brandId, data) => {
  return {
    types: [UPDATE_SIFT_FRAUD_CONFIG_REQUESTED, UPDATE_SIFT_FRAUD_CONFIG_SUCCESS, UPDATE_SIFT_FRAUD_CONFIG_FAILURE],
    promise: client => client.post(`updateSiftConfig/${brandId}`, { data })
  };
};
